var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 14.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #95989a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_196540_cc",
    transform: "translate(200.7 -230.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-1",
    d: "M-178.783,233.14h-3.062V230.9h-14.574v2.807H-200.7v.936h4.281v1.9h-3.516v.936h3.516v1.9h-2.835v.936h2.835v3.573h2.722a2.081,2.081,0,0,0,2.07,1.786,2.081,2.081,0,0,0,2.07-1.786h8.534a2.081,2.081,0,0,0,2.07,1.786,2.081,2.081,0,0,0,2.07-1.786h2.183v-6.153C-174.757,234.955-176.345,233.14-178.783,233.14Zm-12.872,11.625a1.137,1.137,0,0,1-1.134-1.134,1.138,1.138,0,0,1,1.134-1.134,1.138,1.138,0,0,1,1.134,1.134A1.138,1.138,0,0,1-191.655,244.765Zm8.846-1.786h-6.861a2.113,2.113,0,0,0-1.985-1.446,2.1,2.1,0,0,0-1.985,1.446h-1.871V231.864h12.7v11.115Zm3.8,1.786a1.138,1.138,0,0,1-1.134-1.134,1.138,1.138,0,0,1,1.134-1.134,1.137,1.137,0,0,1,1.134,1.134A1.137,1.137,0,0,1-179.01,244.765Zm3.289-1.786h-1.3a2.113,2.113,0,0,0-1.985-1.446,2.077,2.077,0,0,0-1.985,1.446h-.879v-8.9h3.062c1.9,0,3.062,1.418,3.062,3.686v5.217Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingDetails);
export default __webpack_public_path__ + "static/media/shippingDetails.d0b844c6e389c0a008aa0a67daadb6ba.svg";
export { ForwardRef as ReactComponent };